import logFactory, { LogLevels } from 'c9-js-log-client';
import { ResourceContextProvider } from '@flos/react-ui';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './App';
import resource from './resources.json';
import { store } from './store';
import { settingsActions } from './store/settings.slice';
import { userActions } from './store/user.slice';
import log, { registerLogger } from './utils/logger';
import { ActiveUser, ConfigObject } from 'top-context';

let context = window || {};

context.HybridApp = (function () {
  function boostrapApplication(
    config: ConfigObject & { appName: string },
    user: ActiveUser | undefined,
    boostrapElement: HTMLElement,
    logLevel = ''
  ) {
    const level = (isLogLevel(logLevel) ? logLevel : config.getSiteConfig().logLevel) as LogLevels;
    const logger = logFactory(config.getEndpointConfig().logger, config.appName, level);
    registerLogger(logger);
    log.debug(`Starting up application ${logger.appName}`);

    store.dispatch(
      settingsActions.setSettings({
        appName: config.appName,
        endpointConfig: config.getEndpointConfig(),
        siteConfig: config.getSiteConfig(),
      })
    );

    store.dispatch(userActions.setActiveUser(user));

    ReactDOM.render(
      <Provider store={store}>
        <ResourceContextProvider
          resourceEndpoint={`${config.getEndpointConfig().resourceBundle}/ninjas-write-to-us-app`}
          initialResource={resource}
        >
          <App />
        </ResourceContextProvider>
      </Provider>,
      boostrapElement
    );
  }

  return boostrapApplication;
})();

function isLogLevel(value: string): value is LogLevels {
  return Object.keys(LogLevels).includes(value);
}
